import React, { useEffect, useState } from "react";

import {
  Button,
  Card,
  Col,
  Form,
  Spinner,
  ToggleButton,
  ToggleButtonGroup,
} from "@deere/ux.uxframe-react";
import { CustList } from "./CustomerList";
import { useDispatch, useSelector } from "react-redux";
import {
  customerSearchError,
  getCustomers,
  resetCustomerList,
  setCustCountryError,
  setSelectedCustomerType,
} from "./customersSlice";
import {
  countries as countryList,
  getCountries,
  getStates,
  states as stateList,
} from "./referenceSlice";
import { useHistory, matchPath } from "react-router-dom";
import { languageResponseData } from "../Translation/translationSerachSlice";

const CustomerSearch = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const translationsResponse = useSelector(languageResponseData);

  const userType = useSelector(state => state.customers.selectedCustomerType);
  const [lastNameOrBusinessName, setLastNameOrBusinessName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [countryCd, setCountyCd] = useState("");
  const [stateCd, setStateCd] = useState("");
  const [city, setCity] = useState("");

  const countries = useSelector(countryList);
  const states = useSelector(stateList);
  const custLoading = useSelector((state) => state.customers.loading);
  let custSearchError = useSelector(customerSearchError);
  const [validationError, setValidationError] = useState("");
  const [stateOptionData, setStateOptionsData] = useState([]);
  const [countryOptionData, setCountryOptionsData] = useState([]);

  const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
  };

  useEffect(() => {
    
    if (history?.location?.state?.userType) {
      
      /*Populate previous search form data*/
      if (history?.location?.state?.customer) {
        const customer = history?.location?.state?.customer;
        setLastNameOrBusinessName(customer.lastNameOrBusinessName);
        setFirstName(customer.firstNameOrFamiliarName);
        setCountyCd(
          customer.address?.city ||
            (customer.addresses &&
            Array.isArray(customer.addresses) &&
            customer.addresses.length > 0
              ? customer.addresses[0]?.city
              : null)
        );
        setCountyCd(
          customer.address?.countryCode ||
            (customer.addresses &&
            Array.isArray(customer.addresses) &&
            customer.addresses.length > 0
              ? customer.addresses[0]?.country
              : null)
        );
        setStateCd(
          customer.address?.stateCodes?.[0] ||
            (customer.addresses &&
            Array.isArray(customer.addresses) &&
            customer.addresses.length > 0
              ? customer.addresses[0]?.state
              : null)
        );
      }
    }
    if (countries?.length === 0) {
      dispatch(getCountries({ locale: "en_US" }));
    }

    
  }, [history.location.state]);

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
        const match = matchPath(location.pathname, {
            path: '/machine-search/customer/:somenumber/machines',
            exact: true,
            strict: false,
          });
      if (!match) {
        dispatch(resetCustomerList());
        setLastNameOrBusinessName("");
        setFirstName("");
        setMiddleName("");
        setCountyCd("");
        setStateCd("");
        setCity("");
        setStateOptionsData([]);
         
      }
    });

    return () => {
      unlisten();
    };
  }, [dispatch, history]);

   useEffect(() => {
    let countryOptions = [];
    if (countries && countries.length) {
      countryOptions = countries.map((country) => {
        return (
          <option key={country.iso2CountryCode} value={country.iso2CountryCode}>
            {country.countryShortName}
          </option>
        );
      });
      setCountryOptionsData(countryOptions);
    }
   }, [countries]);

   useEffect(() => {

    let stateOptions = [];
    if (states && Array.isArray(states) && states.length) {
      stateOptions = states.map((state, index) => {
        return (
          <option key={index} value={state.stateCode}>
            {state.stateDesc}
          </option>
        );
      });
      setStateOptionsData(stateOptions);
    }
   }, [states]);
  


  const onSearchCustomerSubmit = (event) => {
    event.preventDefault();
    setValidationError("");
    if (!stateCd && !city) {
      setValidationError("Please enter either State or City");
      return;
    }
    if (
      countryCd === "-1" ||
      countryCd === "" ||
      (states.length > 0 && stateCd.length === 0)
    ) {
      dispatch(setCustCountryError());
    } else {
      let custSearchObj;
      if (userType === "I") {
        custSearchObj = {
          lastNameOrBusinessName: lastNameOrBusinessName.trim().toUpperCase(),
          firstNameOrFamiliarName: firstName.trim().toUpperCase(),
          address: {
            countryCode: countryCd?.trim().toUpperCase(),
            stateCodes:
              stateCd?.length > 0 ? [stateCd?.trim().toUpperCase()] : [],
            addressComponents: [
              {
                addressComponentCode: 3,
                addressComponentValue: city?.trim().toUpperCase(),
              },
            ],
          },
          customerType: ["INDIVIDUAL"],
        };
      } else {
        custSearchObj = {
          lastNameOrBusinessName: lastNameOrBusinessName.trim().toUpperCase(),
          firstNameOrFamiliarName: "",
          address: {
            countryCode: countryCd.trim().toUpperCase(),
            stateCodes:
              stateCd?.length > 0 ? [stateCd?.trim().toUpperCase()] : [],
            addressComponents: [
              {
                addressComponentCode: 3,
                addressComponentValue: city.trim().toUpperCase(),
              },
            ],
          },
          customerType: ["BUSINESS"],
        };
      }
    //   history.push({
    //     pathname: history.location.pathname,
    //     state: { userType, customer: custSearchObj },
    //   });
      dispatch(getCustomers(custSearchObj));
    }
  };

  const onSelectUserType = (e) => {
    /*Select user type for customer*/
    dispatch(setSelectedCustomerType(e.target.value));
    dispatch(resetCustomerList());
    setLastNameOrBusinessName("");
    
        setFirstName("");
        setMiddleName("");
      
        setStateCd("");
        setCity("");
        
        setStateOptionsData([]);
        setCountyCd("");
       
    /*history.push({ pathname: history.location.pathname, state: { userType: e.target.value } });*/
  };

  /*const onClearForm = (e) => {
          console.log("In clear")
          setUserType("I");
          setLastNameOrBusinessName("");
          setFirstName("");
          setMiddleName("");
          setCountyCd("");
          setStateCd("");
          setCity("");
      };*/

  return (
    <div>
      {/*<pre>{JSON.stringify(userType)}</pre>*/}
      <Card>
        <Card.Body>
          <Form onSubmit={onSearchCustomerSubmit}>
            <Form.Row>
              <Form.Group controlId="customerType">
                <ToggleButtonGroup
                  role="toolbar"
                  className="mt-3"
                  name="businessIndicator"
                  type="radio"
                  value={userType}
                  ariaLabel="Customer Type Business/Individual"
                  onClick={(e) => onSelectUserType(e)}
                >
                  <ToggleButton value="I">
                    {translate("individual", "Individual")}
                  </ToggleButton>
                  <ToggleButton value="B">
                    {translate("business", "Business")}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Form.Group>
            </Form.Row>
            {userType === "I" ? (
              <Form.Row>
                <Form.Group as={Col} controlId="formGridLastName">
                  <Form.Label className="uxf-label">
                    {translate("lastName", "Last Name ")}
                    <span
                      aria-label="field required"
                      className="uxf-is-required"
                    >
                      *
                    </span>
                  </Form.Label>
                  <Form.Control
                    required
                    value={lastNameOrBusinessName}
                    onChange={(e) => setLastNameOrBusinessName(e.target.value)}
                    placeholder={translate(
                      "enter_last_name",
                      "Enter Last Name "
                    )}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridMiddleName">
                  <Form.Label className="uxf-label">
                    {translate("middle_name", "Middle Name")}
                  </Form.Label>
                  <Form.Control
                    value={middleName}
                    onChange={(e) => setMiddleName(e.target.value)}
                    placeholder={translate(
                      "enter_middle_name",
                      "Enter Middle Name "
                    )}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridFirstName">
                  <Form.Label className="uxf-label">
                    {translate("firstName", "First Name ")}
                  </Form.Label>
                  <Form.Control
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder={translate(
                      "enter_first_name",
                      "Enter First Name"
                    )}
                  />
                </Form.Group>
              </Form.Row>
            ) : (
              <Form.Row>
                <Form.Group
                  as={Col}
                  controlId="formGridBusinessName"
                  className="col-12"
                >
                  <Form.Label className="uxf-label">
                    {translate("business", " Business ")}
                    <span
                      aria-label="field required"
                      className="uxf-is-required"
                    >
                      *
                    </span>
                  </Form.Label>
                  <Form.Control
                    value={lastNameOrBusinessName}
                    onChange={(e) => setLastNameOrBusinessName(e.target.value)}
                    required
                    placeholder={translate(
                      "enter_business_name",
                      "Enter Business Name"
                    )}
                  />
                </Form.Group>
              </Form.Row>
            )}
            <Form.Row>
              <Form.Group as={Col} controlId="formGridCountry">
                <Form.Label className="uxf-label">
                  {translate("country", "Country")}
                  <span aria-label="required field" className="uxf-is-required">
                    *
                  </span>
                </Form.Label>
                <Form.Control
                  required
                  placeholder={translate("enter_Country", "Enter Country")}
                  as="select"
                  value={countryCd}
                  onChange={(e) => {
                    if (e.target.value !== -1) setCountyCd(e.target.value);
                    setStateCd("");
                    dispatch(
                      getStates({
                        countryCode: e.target.value,
                        locale: "en_US",
                      })
                    );
                  }}
                >
                  <option key="-1" value="-1">
                    {translate("selectCountry", "Select Country...... ")}
                  </option>
                  {countryOptionData}
                </Form.Control>
              </Form.Group>
              {states && Array.isArray(states) && states.length ? (
                <Form.Group as={Col} controlId="formGridState">
                  <Form.Label className="uxf-label">
                    {translate("stateProvince", "State/Province ")}
                    <span
                      aria-label="required field"
                      className="uxf-is-required"
                    >
                      *
                    </span>
                  </Form.Label>
                  <Form.Control
                    
                    required
                    as="select"
                    onChange={(e) => {
                      if (e.target.value !== -1) setStateCd(e.target.value);
                    }}
                  >
                    <option value="-1">
                      {translate("PleaseSelectMessg", "Please Select....")}
                    </option>
                    {stateOptionData}
                  </Form.Control>
                </Form.Group>
              ) : (
                <Form.Group as={Col} controlId="formGridState">
                  <Form.Label className="uxf-label">
                    {translate("stateProvince", "State ")}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setStateCd(e.target.value)}
                    placeholder={translate("enter_state", "Enter State")}
                  />
                </Form.Group>
              )}
              <Form.Group as={Col} controlId="formGridCity">
                <Form.Label className="uxf-label">
                  {translate("city", "City ")}
                </Form.Label>
                <Form.Control
                value={city}
                  onChange={(e) => setCity(e.target.value)}
                  placeholder={translate("enter_city", "Enter City")}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Button variant="primary" type="submit">
                {translate("search", "Search")}
              </Button>
              &nbsp;&nbsp;
            </Form.Row>
          </Form>
          {validationError && (
            <span
              style={{
                color: "red",
                marginTop: "0.5em",
                fontSize: "20px",
                marginLeft: "300px",
              }}
            >
              {`${validationError}`}
            </span>
          )}

          {custSearchError && !validationError ? (
            custSearchError === "countryNotSelected" ? (
              userType === "I" ? (
                <span
                  style={{
                    color: "red",
                    marginTop: "0.5em",
                    fontSize: "20px",
                    marginLeft: "300px",
                  }}
                >
                  {translate(
                    "message4",
                    '"Last Name" must be accompanied by Country and (City or State/Prov).'
                  )}
                </span>
              ) : userType === "B" ? (
                <span
                  style={{
                    color: "red",
                    marginTop: "0.5em",
                    fontSize: "20px",
                    marginLeft: "300px",
                  }}
                >
                  {translate(
                    "message5",
                    '"Business Name" must be accompanied by Country and (City or State/Prov).'
                  )}
                </span>
              ) : null
            ) : (
              <span
                style={{
                  color: "red",
                  marginTop: "0.5em",
                  fontSize: "20px",
                  marginLeft: "300px",
                }}
              >
                {translate("message17", "No Customer found for this criteria.")}
              </span>
            )
          ) : (
            <></>
          )}
        </Card.Body>
      </Card>
      {custLoading && !validationError ? (
        <div className="d-flex w-100 justify-content-center align-items-center">
          <Spinner
            accessibilityLabel="Loading"
            className="uxf-spinner-border-lg"
            animation="border"
          />
        </div>
      ) : (
        <CustList userType={userType} />
      )}
    </div>
  );
};
export default CustomerSearch;
